import {
    CLOSE_EDIT_VERSION_MODEL,
    OPEN_CREATE_PUMPFAMILY_MODEL,
    OPEN_EDIT_VERSION_MODEL,
    SET_VERSION_PENDING,
    SET_VERSION,
    UPDATE_VERSION_PENDING,
    UPDATE_VERSION_SUCCESS,
    UPDATE_VERSION_ERROR,
    CLEAR_UPDATE_VERSION_ERROR,
    CLOSE_CREATE_PUMPFAMILY_MODEL,
    SET_MAINT_FAMILY_PENDING,
    SET_MAINT_FAMILY_LIST,
    CREATE_PUMPFAMILY_ERROR,
    CLEAR_PUMPFAMILY_ERROR,
    CREATE_PUMPFAMILY_PENDING,
    CREATE_PUMPFAMILY_SUCCESS,
    SET_LOCK_EDITING,
    SET_PUMPFAMILY_DETAILS,
    OPEN_EDIT_PUMPFAMILY_MODEL,
    CLOSE_EDIT_PUMPFAMILY_MODEL,
    CLEAR_UPDATE_PUMPFAMILY_ERROR,
    UPDATE_PUMPFAMILY_PENDING,
    UPDATE_PUMPFAMILY_SUCCESS,
    UPDATE_PUMPFAMILY_ERROR,
    SET_MAINT_PUMPDATA_PENDING,
    SET_MAINT_PUMPDATA_LIST,
    SET_ACTIVE_PUMP_DATA,
    CLEAR_PUMP_DETAILS,
    UPDATE_PUMP_ERROR,
    CREATE_PUMP_ERROR,
    CLEAR_UPDATE_PUMP_ERROR,
    CLEAR_CREATE_PUMP_ERROR,
    UPDATE_PUMP_PENDING,
    UPDATE_PUMP_SUCCESS,
    CLOSE_EDIT_PUMP_MODEL,
    CLOSE_ADD_PUMP_MODEL,
    OPEN_CREATE_PIPEMATERIAL_MODEL,
    CLOSE_CREATE_PIPEMATERIAL_MODEL,
    SET_MAINT_PIPEMATERIAL_PENDING,
    SET_MAINT_PIPEMATERIAL_LIST,
    CREATE_PIPEMATERIAL_ERROR,
    CLEAR_PIPEMATERIAL_ERROR,
    CREATE_PIPEMATERIAL_PENDING,
    CREATE_PIPEMATERIAL_SUCCESS,
    SET_PIPEMATERIAL_DETAILS,
    OPEN_EDIT_PIPEMATERIAL_MODEL,
    CLOSE_EDIT_PIPEMATERIAL_MODEL,
    CLEAR_UPDATE_PIPEMATERIAL_ERROR,
    UPDATE_PIPEMATERIAL_PENDING,
    UPDATE_PIPEMATERIAL_SUCCESS,
    UPDATE_PIPEMATERIAL_ERROR,
    OPEN_CREATE_PIPEELEMENTFAMILY_MODEL,
    CLOSE_CREATE_PIPEELEMENTFAMILY_MODEL,
    SET_MAINT_PIPEELEMENTFAMILY_PENDING,
    SET_MAINT_PIPEELEMENTFAMILY_LIST,
    CREATE_PIPEELEMENTFAMILY_ERROR,
    CLEAR_PIPEELEMENTFAMILY_ERROR,
    CREATE_PIPEELEMENTFAMILY_PENDING,
    CREATE_PIPEELEMENTFAMILY_SUCCESS,
    SET_PIPEELEMENTFAMILY_DETAILS,
    OPEN_EDIT_PIPEELEMENTFAMILY_MODEL,
    CLOSE_EDIT_PIPEELEMENTFAMILY_MODEL,
    CLEAR_UPDATE_PIPEELEMENTFAMILY_ERROR,
    UPDATE_PIPEELEMENTFAMILY_PENDING,
    UPDATE_PIPEELEMENTFAMILY_SUCCESS,
    UPDATE_PIPEELEMENTFAMILY_ERROR,
    OPEN_CREATE_PIPEELEMENT_MODEL,
    CLOSE_CREATE_PIPEELEMENT_MODEL,
    SET_MAINT_PIPEELEMENT_PENDING,
    SET_MAINT_PIPEELEMENT_LIST,
    CREATE_PIPEELEMENT_ERROR,
    CLEAR_PIPEELEMENT_ERROR,
    CREATE_PIPEELEMENT_PENDING,
    CREATE_PIPEELEMENT_SUCCESS,
    SET_PIPEELEMENT_DETAILS,
    OPEN_EDIT_PIPEELEMENT_MODEL,
    CLOSE_EDIT_PIPEELEMENT_MODEL,
    CLEAR_UPDATE_PIPEELEMENT_ERROR,
    UPDATE_PIPEELEMENT_PENDING,
    UPDATE_PIPEELEMENT_SUCCESS,
    UPDATE_PIPEELEMENT_ERROR,
    SET_ACTIVE_PIPEELEMENT,
    SET_ACCESS_PENDING,
    SET_ACCESS_STATUS,
    SET_LOCKVALUE_PENDING,
    // SET_LOCKSCREEN
    OPEN_RELEASE_MODEL,
    CLOSE_RELEASE_MODEL,
  SET_REFRESH_LOG_PENDING,
  SET_REFRESH_LOG,
  OPEN_RELEASE_COMMENTS_MODEL,
  CLOSE_RELEASE_COMMENTS_MODEL,
  SET_RELEASE_BOOLEAN,
  SET_RELEASE_ERROR,
  CLEAR_ACCESS_STATUS_PENDING,
  CLEAR_ACCESS_STATUS_SUCCESS,
  CLEAR_OVERRIDE_PENDING,
  CLEAR_OVERRIDE_SUCCESS,
  SET_LOCK_ERROR,
  SET_AVAILABLE_VALUES,
  SET_RELEASEDB_PENDING,
  SET_RELEASEDB,
} from "../constants//maintenance.constants";
import { MaintenanceLocalState } from "../../types/maintenance";

const initialState: MaintenanceState = {
    isEditVersionModelOpen: false,
    isCreatePumpFamilyModelOpen: false,
    isEditPumpFamilyModelOpen: false,
    isGetMaintPumpDataPending: false,
    lockEditing: false,
    pumpFamily: [],
    activePumpFamily: {label: "TopGear GS", value: "55ACFE60-0471-493F-914E-B40F14CA4883"},
    isCreatePipeMaterialModelOpen: false,
    isEditPipeMaterialModelOpen: false,
    pipeMaterial: [],
    isCreatePipeElementFamilyModelOpen: false,
    isEditPipeElementFamilyModelOpen: false,
    pipeElementFamily: [],
    isCreatePipeElementModelOpen: false,
    isEditPipeElementModelOpen: false,
    isGetMaintPipeElementPending: false,
    pipeElement: [],
    activePipeElementFamily: {label: "Elbows 90°", value: "4F1416B9-1C0E-40BE-977E-2ECAF0D07496"},
};

export default (
    localState: MaintenanceLocalState = initialState,
    action: Action
): MaintenanceLocalState => {
    switch (action.type) {
        case SET_VERSION: {
            const { version } = action.payload;
            return {
                ...localState,
                isGetVersionPending: false,
                version: version,
            };
        }
        case UPDATE_VERSION_PENDING: {
            return {
                ...localState,
                isUpdateVersionPending: true,
            };
        }
        case UPDATE_VERSION_SUCCESS: {
            return {
                ...localState,
                isUpdateVersionPending: false,
            };
        }
        case UPDATE_VERSION_ERROR: {
            const { errorMessage } = action.payload;
            return {
                ...localState,
                updateVersionErrorMessage: errorMessage,
                isUpdateVersionPending: false,
            };
        }
        case CLEAR_UPDATE_VERSION_ERROR: {
            return {
                ...localState,
                updateVersionErrorMessage: null,
                isUpdateVersionPending: false,
            };
        }
        case SET_VERSION_PENDING: {
            return {
                ...localState,
                isGetVersionPending: true,
            };
        }
        case OPEN_EDIT_VERSION_MODEL:{
            return {
              ...localState,
              isEditVersionModelOpen: true,
            };
          }
        case CLOSE_EDIT_VERSION_MODEL:{
            return {
              ...localState,
              isEditVersionModelOpen: false,
              updateVersionErrorMessage: null,
            };
          }
        case OPEN_CREATE_PUMPFAMILY_MODEL: {
            return {
              ...localState,
              isCreatePumpFamilyModelOpen: true,
            };
          }
          case CLOSE_CREATE_PUMPFAMILY_MODEL: {
            return {
              ...localState,
              isCreatePumpFamilyModelOpen: false,
            };
          }
        case SET_MAINT_FAMILY_PENDING: {
            return {
                ...localState,
                isGetMaintFamilyPending: true
            };
        }
        case SET_MAINT_FAMILY_LIST: {
            const { pumpFamilyOdata } = action.payload;
            return {
                ...localState,
                isGetMaintFamilyPending: false,
                pumpFamily: pumpFamilyOdata
            }
        }
        case CREATE_PUMPFAMILY_ERROR: {
            const { errorMessage } = action.payload;
            return {
                ...localState,
                addPumpFamilyErrorMessage: errorMessage,
                isPending: false,
            };
        }
        case CLEAR_PUMPFAMILY_ERROR: {
            return {
                ...localState,
                addPumpFamilyErrorMessage: null,
                isPending: false,
            };
        }
        case CREATE_PUMPFAMILY_PENDING: {
            return {
                ...localState,
                isPending: true,
            };
        }
        case CREATE_PUMPFAMILY_SUCCESS: {
            return {
                ...localState,
                isPending: false,
            };
        }
        case SET_LOCK_EDITING: {
            return {
                ...localState,
                lockEditing: action.payload
            };
        }
        case SET_PUMPFAMILY_DETAILS: {
            return {
                ...localState,
                pumpFamilyEdit: action.payload,
            };
        }
        case OPEN_EDIT_PUMPFAMILY_MODEL: {
            return {
                ...localState,
                isEditPumpFamilyModelOpen: true,
            };
        }
        case CLOSE_EDIT_PUMPFAMILY_MODEL: {
            return {
                ...localState,
                isEditPumpFamilyModelOpen: false,
                updatePumpFamilyErrorMessage: null,
            };
        }
        case CLEAR_UPDATE_PUMPFAMILY_ERROR: {
            return {
                ...localState,
                updatePumpFamilyErrorMessage: null,
                isUpdatePumpFamilyPending: false,
            };
        }
        case UPDATE_PUMPFAMILY_PENDING: {
            return {
                ...localState,
                isUpdatePumpFamilyPending: true,
            };
        }
        case UPDATE_PUMPFAMILY_SUCCESS: {
            return {
                ...localState,
                isUpdatePumpFamilyPending: false,
            };
        }
        case UPDATE_PUMPFAMILY_ERROR: {
            const { errorMessage } = action.payload;
            return {
                ...localState,
                updatePumpFamilyErrorMessage: errorMessage,
                isUpdatePumpFamilyPending: false,
            };
        }
        case SET_MAINT_PUMPDATA_PENDING: {
            return {
                ...localState,
                isGetMaintPumpDataPending: true,
            };
        }
        case SET_MAINT_PUMPDATA_LIST: {
            const pumpDataOdata = action.payload;
            return {
                ...localState,
                isGetMaintPumpDataPending: false,
                pumpData: pumpDataOdata,
            };
        }
        case SET_ACTIVE_PUMP_DATA: {
            return {
                ...localState,
                activePumpFamily: action.payload,
            };
        }
        case UPDATE_PUMP_ERROR: {
            const { errorMessage } = action.payload;
            return {
                ...localState,
                updatePumpErrorMessage: errorMessage,
                isUpdatePumpPending: false,
            };
        }
        case CREATE_PUMP_ERROR: {
            const { errorMessage } = action.payload;
            return {
                ...localState,
                addPumpErrorMessage: errorMessage,
                isAddPumpPending: false,
            };
        }
        case CLEAR_PUMP_DETAILS: {
            return {
                ...localState,
                PumpDetails: [],
            }
        }
        case CLEAR_UPDATE_PUMP_ERROR: {
            return {
                ...localState,
                updatePumpErrorMessage: null,
                isUpdatePumpPending: false,
            };
        }
        case CLEAR_CREATE_PUMP_ERROR: {
            return {
                ...localState,
                addPumpErrorMessage: null,
                isAddPumpPending: false,
            };
        }
        case UPDATE_PUMP_PENDING: {
            return {
                ...localState,
                isUpdatePumpPending: true,
            };
        }
        case UPDATE_PUMP_SUCCESS: {
            return {
                ...localState,
                isUpdatePumpPending: false,
            };
        }
        case CLOSE_EDIT_PUMP_MODEL: {
            return {
                ...localState,
                isEditPumpModelOpen: false,
                updatePumpErrorMessage: null,
            };
        }
        case CLOSE_ADD_PUMP_MODEL: {
            return{
                ...localState,
                isAddPumpModelOpen: false,
                addPumpErrorMessage: null
            }
        }
        case OPEN_CREATE_PIPEMATERIAL_MODEL: {
            return {
              ...localState,
              isCreatePipeMaterialModelOpen: true,
            };
          }
          case CLOSE_CREATE_PIPEMATERIAL_MODEL: {
            return {
              ...localState,
              isCreatePipeMaterialModelOpen: false,
            };
          }
        case SET_MAINT_PIPEMATERIAL_PENDING: {
            return {
                ...localState,
                isGetMaintPipeMaterialPending: true
            };
        }
        case SET_MAINT_PIPEMATERIAL_LIST: {
            const { pipeMaterialOdata } = action.payload;
            return {
                ...localState,
                isGetMaintPipeMaterialPending: false,
                pipeMaterial: pipeMaterialOdata
            }
        }
        case CREATE_PIPEMATERIAL_ERROR: {
            const { errorMessage } = action.payload;
            return {
                ...localState,
                addPipeMaterialErrorMessage: errorMessage,
                isPending: false,
            };
        }
        case CLEAR_PIPEMATERIAL_ERROR: {
            return {
                ...localState,
                addPipeMaterialErrorMessage: null,
                isPending: false,
            };
        }
        case CREATE_PIPEMATERIAL_PENDING: {
            return {
                ...localState,
                isPending: true,
            };
        }
        case CREATE_PIPEMATERIAL_SUCCESS: {
            return {
                ...localState,
                isPending: false,
            };
        }
        case SET_PIPEMATERIAL_DETAILS: {
            return {
                ...localState,
                pipeMaterialEdit: action.payload,
            };
        }
        case OPEN_EDIT_PIPEMATERIAL_MODEL: {
            return {
                ...localState,
                isEditPipeMaterialModelOpen: true,
            };
        }
        case CLOSE_EDIT_PIPEMATERIAL_MODEL: {
            return {
                ...localState,
                isEditPipeMaterialModelOpen: false,
                updatePipeMaterialErrorMessage: null,
            };
        }
        case CLEAR_UPDATE_PIPEMATERIAL_ERROR: {
            return {
                ...localState,
                updatePipeMaterialErrorMessage: null,
                isUpdatePipeMaterialPending: false,
            };
        }
        case UPDATE_PIPEMATERIAL_PENDING: {
            return {
                ...localState,
                isUpdatePipeMaterialPending: true,
            };
        }
        case UPDATE_PIPEMATERIAL_SUCCESS: {
            return {
                ...localState,
                isUpdatePipeMaterialPending: false,
            };
        }
        case UPDATE_PIPEMATERIAL_ERROR: {
            const { errorMessage } = action.payload;
            return {
                ...localState,
                updatePipeMaterialErrorMessage: errorMessage,
                isUpdatePipeMaterialPending: false,
            };
        }
        case OPEN_CREATE_PIPEELEMENTFAMILY_MODEL: {
            return {
              ...localState,
              isCreatePipeElementFamilyModelOpen: true,
            };
          }
          case CLOSE_CREATE_PIPEELEMENTFAMILY_MODEL: {
            return {
              ...localState,
              isCreatePipeElementFamilyModelOpen: false,
            };
          }
        case SET_MAINT_PIPEELEMENTFAMILY_PENDING: {
            return {
                ...localState,
                isGetMaintPipeElementFamilyPending: true
            };
        }
        case SET_MAINT_PIPEELEMENTFAMILY_LIST: {
            const { pipeElementFamilyOdata } = action.payload;
            return {
                ...localState,
                isGetMaintPipeElementFamilyPending: false,
                pipeElementFamily: pipeElementFamilyOdata
            }
        }
        case CREATE_PIPEELEMENTFAMILY_ERROR: {
            const { errorMessage } = action.payload;
            return {
                ...localState,
                addPipeElementFamilyErrorMessage: errorMessage,
                isPending: false,
            };
        }
        case CLEAR_PIPEELEMENTFAMILY_ERROR: {
            return {
                ...localState,
                addPipeElementFamilyErrorMessage: null,
                isPending: false,
            };
        }
        case CREATE_PIPEELEMENTFAMILY_PENDING: {
            return {
                ...localState,
                isPending: true,
            };
        }
        case CREATE_PIPEELEMENTFAMILY_SUCCESS: {
            return {
                ...localState,
                isPending: false,
            };
        }
        case SET_PIPEELEMENTFAMILY_DETAILS: {
            return {
                ...localState,
                pipeElementFamilyEdit: action.payload,
            };
        }
        case OPEN_EDIT_PIPEELEMENTFAMILY_MODEL: {
            return {
                ...localState,
                isEditPipeElementFamilyModelOpen: true,
            };
        }
        case CLOSE_EDIT_PIPEELEMENTFAMILY_MODEL: {
            return {
                ...localState,
                isEditPipeElementFamilyModelOpen: false,
                updatePipeElementFamilyErrorMessage: null,
            };
        }
        case CLEAR_UPDATE_PIPEELEMENTFAMILY_ERROR: {
            return {
                ...localState,
                updatePipeElementFamilyErrorMessage: null,
                isUpdatePipeElementFamilyPending: false,
            };
        }
        case UPDATE_PIPEELEMENTFAMILY_PENDING: {
            return {
                ...localState,
                isUpdatePipeElementFamilyPending: true,
            };
        }
        case UPDATE_PIPEELEMENTFAMILY_SUCCESS: {
            return {
                ...localState,
                isUpdatePipeElementFamilyPending: false,
            };
        }
        case UPDATE_PIPEELEMENTFAMILY_ERROR: {
            const { errorMessage } = action.payload;
            return {
                ...localState,
                updatePipeElementFamilyErrorMessage: errorMessage,
                isUpdatePipeElementFamilyPending: false,
            };
        }
        case OPEN_CREATE_PIPEELEMENT_MODEL: {
            return {
              ...localState,
              isCreatePipeElementModelOpen: true,
            };
          }
          case CLOSE_CREATE_PIPEELEMENT_MODEL: {
            return {
              ...localState,
              isCreatePipeElementModelOpen: false,
            };
          }
        case SET_MAINT_PIPEELEMENT_PENDING: {
            return {
                ...localState,
                isGetMaintPipeElementPending: true
            };
        }
        case SET_MAINT_PIPEELEMENT_LIST: {
            const { pipeElementOdata } = action.payload;
            return {
                ...localState,
                isGetMaintPipeElementPending: false,
                pipeElement: pipeElementOdata
            }
        }
        case CREATE_PIPEELEMENT_ERROR: {
            const { errorMessage } = action.payload;
            return {
                ...localState,
                addPipeElementErrorMessage: errorMessage,
                isPending: false,
            };
        }
        case CLEAR_PIPEELEMENT_ERROR: {
            return {
                ...localState,
                addPipeElementErrorMessage: null,
                isPending: false,
            };
        }
        case CREATE_PIPEELEMENT_PENDING: {
            return {
                ...localState,
                isPending: true,
            };
        }
        case CREATE_PIPEELEMENT_SUCCESS: {
            return {
                ...localState,
                isPending: false,
            };
        }
        case SET_PIPEELEMENT_DETAILS: {
            return {
                ...localState,
                pipeElementEdit: action.payload,
            };
        }
        case OPEN_EDIT_PIPEELEMENT_MODEL: {
            return {
                ...localState,
                isEditPipeElementModelOpen: true,
            };
        }
        case CLOSE_EDIT_PIPEELEMENT_MODEL: {
            return {
                ...localState,
                isEditPipeElementModelOpen: false,
                updatePipeElementErrorMessage: null,
            };
        }
        case CLEAR_UPDATE_PIPEELEMENT_ERROR: {
            return {
                ...localState,
                updatePipeElementErrorMessage: null,
                isUpdatePipeElementPending: false,
            };
        }
        case UPDATE_PIPEELEMENT_PENDING: {
            return {
                ...localState,
                isUpdatePipeElementPending: true,
            };
        }
        case UPDATE_PIPEELEMENT_SUCCESS: {
            return {
                ...localState,
                isUpdatePipeElementPending: false,
            };
        }
        case UPDATE_PIPEELEMENT_ERROR: {
            const { errorMessage } = action.payload;
            return {
                ...localState,
                updatePipeElementErrorMessage: errorMessage,
                isUpdatePipeElementPending: false,
            };
        }
        case SET_ACTIVE_PIPEELEMENT: {
            return {
                ...localState,
                activePipeElementFamily: action.payload,
            };
        }
        case SET_ACCESS_PENDING:{
            return {
              ...localState,
              accessStatusPending: true,
            }
          }
        case SET_ACCESS_STATUS: {
            return {
              ...localState,
              accessStatus: action.payload,
            }
          }
        case SET_LOCKVALUE_PENDING:{
            return {
              ...localState,
              lockPending: true,
            }
          }
          case OPEN_RELEASE_MODEL: {
            return {
              ...localState,
              openRelease: true,
            }
          }
          case CLOSE_RELEASE_MODEL: {
            return {
              ...localState,
              openRelease: false,
            }
          }
          case SET_REFRESH_LOG_PENDING: {
            return {
              ...localState,
              getReleaseLogPending: true,
            };
          }
          case SET_REFRESH_LOG: {
            return {
              ...localState,
              getReleaseLogPending: false,
              releaseLog: action.payload,
            };
          }
          case OPEN_RELEASE_COMMENTS_MODEL: {
            return {
              ...localState,
              openReleaseComments: true,
            }
          }
          case CLOSE_RELEASE_COMMENTS_MODEL: {
            return {
              ...localState,
              openReleaseComments: false,
            }
          }
          case SET_RELEASE_BOOLEAN: {
            return {
              ...localState,
              releaseBoolean: action.payload,
            }
          }
          case SET_RELEASE_ERROR: {
            return {
              ...localState,
              releaseError: action.payload,
            }
          }
          case CLEAR_ACCESS_STATUS_PENDING: {
            return {
              ...localState,
              clearAccessPending: true,
            }
          }
          case CLEAR_ACCESS_STATUS_SUCCESS: {
            return {
              ...localState,
              clearAccessPending: false,
            }
          }
          case CLEAR_OVERRIDE_PENDING: {
            return {
              ...localState,
              clearOverridePending: true,
            }
          }
          case CLEAR_OVERRIDE_SUCCESS: {
            return {
              ...localState,
              clearOverridePending: false,
            }
          }
          case SET_LOCK_ERROR: {
            return {
              ...localState,
              lockError: action.payload,
            }
          }
          case SET_AVAILABLE_VALUES: {
            return {
              ...localState,
              editAvailable: action.payload,
            }
          }
          case SET_RELEASEDB_PENDING: {
            return {
              ...localState,
              releasePending: true,
            }
          }
          case SET_RELEASEDB: {
            return {
              ...localState,
              releaseData: action.payload,
            }
          }
        default: {
            return localState;
        }
    }
}